$('.check-all').change(function(){
  $checkAll = $(this);
  $('.'+$checkAll.attr('data-check')).prop('checked', $checkAll.prop('checked'));
});

